var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 18,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FD2828",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M13.571 2.122H7.43c-2.179 0-2.66.93-2.94 2.07L3.5 8.25h14l-.989-4.058c-.28-1.14-.761-2.07-2.94-2.07M19.241 14.865c.096.877-.726 1.635-1.776 1.635H15.82c-.945 0-1.076-.345-1.243-.773l-.175-.45c-.245-.614-.402-1.027-1.662-1.027H8.26c-1.26 0-1.444.465-1.663 1.027l-.175.45c-.166.428-.297.773-1.242.773H3.535c-1.05 0-1.873-.758-1.776-1.635l.49-4.568c.122-1.125.376-2.047 2.668-2.047h11.165c2.293 0 2.547.922 2.67 2.047zM3.5 6h-.875M18.375 6H17.5M10.5 2.25v1.5M9.188 3.75h2.624M5.25 11.25h2.625M13.125 11.25h2.625"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.8afa2b0e2ff90a6f87556976617eace5.svg";
export { ForwardRef as ReactComponent };